<app-cashregister-search-items 
    [getItemStockStatus]="getItemStockStatus" 
    (showItem)="showItem.emit($event)" 
    (addItemToSale)="addItemToSale.emit($event)" 
    [priceList]="priceListStr"  
    (searchItems)="searchItems($event)" 
    [searchResults]="searchResults" 
    [isLoading]="isLoading" 
    [visibleCategories]="visibleCategories" 
    [selectedCategory]="selectedCategory" 
    [showUnavailable]="showUnavailable" 
    [showPrices]="showPrices"
    [fontNameSize]="fontNameSize"
    [fontPriceSize]="fontPriceSize"
    [showItemIcon]="showItemIcon" >
</app-cashregister-search-items>
